import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  IconButton,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { ReactComponent as DeleteIcon } from 'assets/icons/Delete.svg';
// import { InputField, LabelField, SelectField } from 'components';
import { DateTimePickerField } from 'components/DateTime/DateTimePicker';
import { InputField, LabelField, SelectField, HintField } from 'components';
import { getIn } from 'formik';
import { MyCheckbox } from 'components/MyCheckbox';
import { getDateFormat, getDateFormatForDatePicket, maskDate } from 'helper/dateFormat';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { toastr } from 'react-redux-toastr';
import MaskedInput from 'react-text-mask';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { getOrganizationInfoFromLocalStorage } from 'utils/functions';
import './DiscountAccordion.scss';
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { fontConfig, fontFamilies } from "theme/fontConfig";
const DiscountAccordion = ({
  summary,
  body,
  formik,
  handleDeleteClick,
  index,
  isExpanded,
  handleExpand,
}) => {
  const orgDetails = getOrganizationInfoFromLocalStorage();
  const dateMask = maskDate();
  const placeholderFormat = getDateFormat();
  const dateFormat = getDateFormatForDatePicket();
const discountErrors = getIn(formik.errors, `discount[${index}]`);
const discountTouched = getIn(formik.touched, `discount[${index}]`);

const hasDiscountError =
  discountErrors &&
  discountTouched &&
  Object.keys(discountErrors).length > 0;

  const [maxDate, setMaxDate] = useState('');
  const autoCorrectedDatePipe = createAutoCorrectedDatePipe(dateFormat || 'mm/dd/yyyy');

  useEffect(() => {
    const currentDate = new Date();
    const maxDate = new Date(
      currentDate.getFullYear() + 100,
      currentDate.getMonth(),
      currentDate.getDate()
    );
    setMaxDate(maxDate.toISOString().slice(0, 10));
  }, []);

  const minDate = moment(Date.now()).format('YYYY-MM-DD');
  const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;

  function convertUTCToLocalDate(date) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate()
    );
    return date;
  }

  function convertLocalToUTCDate(date, name) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    );
    formik.setFieldValue(name, date);
    return date;
  }
console.log( formik.errors);
  return (
    <div
      className={
        isExpanded
          ? `class_discount_accordion expanded_height`
          : 'class_discount_accordion'
      }
      key={index}
    >
      <Accordion expanded={isExpanded} onChange={handleExpand}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          // aria-controls="panel1a-content"
          // id="panel1a-header"
          className="align-items-center"
        >
          {
            <div className="d-flex align-items-center justify-content-between w-100 accordion_summary">
          <span className='d-flex align-items-center justify-content-between'>    {summary} {hasDiscountError && (
  <ErrorOutlineIcon
    style={{ color: "#dc3545", fontSize: 18, marginLeft: 6 }}
  />
)}</span>
              <IconButton
                onClick={handleDeleteClick}
                aria-label="delete"
                style={{
                  marginLeft: '-81px',
                  fontFamily: fontFamilies.primary,
                  fontWeight: '400',
                  fontSize: '12px',
                  lineHeight: '18px',
                  color: '#4F4F4F',
                }}
              >
                <DeleteIcon className="mr-3" />
                delete
              </IconButton>
            </div>
          }
        </AccordionSummary>
        <AccordionDetails>
          <div className="w-100">
            <Row style={{ marginBottom: '20px' }}>
              <Col className="col-sm-6">
                <InputField
                  titleStyle={{
                    fontFamily: fontConfig.GeneralInputFieldFont.family,
                    fontWeight: '400',
                    fontSize: '12px',
                    lineHeight: '18px',
                    color: '#4F4F4F',
                  }}
                  style={{ backgroundColor: '#FFFFFF' }}
                  mandatory={true}
                  formik={formik}
                  title="Discount Name"
                  name={`discount[${index}].discount_name`}
                  placeholder="Discount Name"
                  checkValidation={true}
                  value={formik.values?.discount?.[index]?.discount_name}
                  handleChange={(e) => {
                    formik.handleChange(e);
                    formik.setFieldTouched(`discount[${index}].discount_name`, true, false);
                  }}
                  maxLength={50}
                  onBlur={formik.handleBlur}
                />
              </Col>
              <Col className="col-sm-6">
                <div
                  className="price_radio_group position-relative d-flex justify-content-end"
                  style={{
                    marginBottom: '-30px',
                    zIndex: '999',
                  }}
                >
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    // defaultValue="fixed_price"
                    name="radio-buttons-group"
                    row
                    value={formik.values?.discount?.[index]?.price_type}
                    onChange={(e) => {
                      formik.setFieldValue(`discount[${index}].value`, "");
                      formik.setFieldValue(
                        `discount[${index}].price_type`,
                        e.target.value
                      );
                    }}
                  >
                    <FormControlLabel
                      value="fixed"
                      control={<Radio className="mr-2" />}
                      label="Fixed Price"
                    />
                    <FormControlLabel
                      value="percentage"
                      control={<Radio className="mr-2" />}
                      label="Percentage"
                    />
                  </RadioGroup>
                </div>
                <InputField
                  titleStyle={{
                    fontFamily: fontConfig.GeneralInputFieldFont.family,
                    fontWeight: '400',
                    fontSize: '12px',
                    lineHeight: '18px',
                    color: '#4F4F4F',
                  }}
                  style={{ backgroundColor: '#FFFFFF' }}
                  mandatory={true}
                  formik={formik}
                  title="Value"
                  name={`discount[${index}].value`}
                  placeholder="Value"
                  checkValidation={true}
                  value={formik.values?.discount?.[index]?.value}
                  handleChange={(e) => {
                    let value = e?.target?.value.match(regex)[0] || "";
                    const maxVal = formik.values?.discount?.[index]?.price_type === 'percentage' ? 100 : 10000;
                    if (parseFloat(value) > maxVal) value = maxVal.toString();
                    formik.setFieldValue(`discount[${index}].value`, value);
                  }}
                  onKeyPress={(event) => {
                    if (event.key === 'Enter') {
                      event.preventDefault();
                    }
                  }}
                  onBlur={formik.handleBlur}
                  max={
                    formik.values?.discount?.[index]?.price_type === 'percentage'
                      ? 100
                      : 10000
                  }
                />
              </Col>
            </Row>
            <Row>
              <Col className="col-sm-6">
                <SelectField
                  mandatory={true}
                  titleStyle={{
                    fontFamily: fontConfig.GeneralSelectFieldFont.family,
                    fontWeight: '400',
                    fontSize: '12px',
                    lineHeight: '18px',
                    color: '#4F4F4F',
                  }}
                  style={{ backgroundColor: '#FFFFFF' }}
                  formik={formik}
                  title="Discount Type"
                 name={`discount[${index}].discount_type`} 
                  placeholder="Discount Type"
                  checkValidation={true}
                  items={['Date', 'Amount']}
                  value={formik.values?.discount?.[index]?.discount_type}
                  onClick={(data) => {
                    // if (
                    //   index !== 0 &&
                    //   formik.values?.discount_type &&
                    //   formik.values?.discount_type !== data
                    // ) {
                    //   toastr.info(
                    //     'Validation',
                    //     'The discount type for all discounts must be the same.'
                    //   );
                    //   return;
                    // }
                    formik.setFieldValue(
                      `discount[${index}].discount_type`,
                      data
                    );
                  }}
                  onBlur={formik.handleBlur} 
                />
              </Col>
              {formik.values?.discount?.[
                index
              ]?.discount_type?.toLowerCase() === 'date' && (
                <>
                  <Col className="col-sm-3">
                    <LabelField title={'Start Date'} mandatory />
                    <DatePicker
                      isClearable
                      showIcon
              
                      placeholderText={placeholderFormat}
                      dateFormat={dateFormat}
                      selected={
                        formik.values.discount?.[index]?.start_date &&
                        convertUTCToLocalDate(
                          formik.values.discount?.[index]?.start_date
                        )
                      }
                      // onChange={(e) => {
                      //   if (formik.values.discount?.[index]?.end_date && e > formik.values.discount?.[index]?.end_date) {
                      //     toastr.info(
                      //       'Validation',
                      //       'Start date should be less than end date.'
                      //     );
                      //     return;
                      //   }
                      //   formik.setFieldValue(
                      //     `discount[${index}].start_date`,
                      //     e
                      //   );
                      //   convertLocalToUTCDate(
                      //     e,
                      //     `discount[${index}].start_date`
                      //   );
                      // }}
                        onChange={(e) => {
                          if (formik.values.discount?.[index]?.end_date && e > formik.values.discount?.[index]?.end_date) {
                          toastr.info(
                            'Validation',
                            'Start date should be less than end date.'
                          );
                          return;
                        }
    formik.setFieldValue(
      `discount[${index}].start_date`,
      e
    );
    convertLocalToUTCDate(
      e,
      `discount[${index}].start_date`
    );
  }}
  onBlur={() =>
    formik.setFieldTouched(
      `discount[${index}].start_date`,
      true
    )
  } 
                      minDate={new Date()}
                      maxDate={
                        formik.values?.registration_ends 
                      }
                      customInput={
                        <MaskedInput
                          pipe={autoCorrectedDatePipe}
                          mask={dateMask}
                          keepCharPositions={true}
                          guide={true}
                        />
                      }
                    />
                    {/* {formik.touched?.discount?.[index]?.start_date &&
  formik.errors?.discount?.[index]?.start_date && (
    <div className="invalid-feedback d-block">
      {formik.errors.discount[index].start_date}
    </div>
)} */}
{getIn(formik.touched, `discount[${index}].start_date`) &&
  getIn(formik.errors, `discount[${index}].start_date`) && (
    <HintField
      error={getIn(formik.errors, `discount[${index}].start_date`)}
    />
)}
                  </Col>
                  <Col className="col-sm-3">
                    <LabelField title={'End Date'} mandatory />
                    <DatePicker
                      isClearable
                      showIcon
                      placeholderText={placeholderFormat}
                      dateFormat={dateFormat}
                      selected={
                        formik.values.discount?.[index]?.end_date &&
                        convertUTCToLocalDate(
                          formik.values.discount?.[index]?.end_date
                        )
                      }
                      onChange={(e) => {
                        formik.setFieldValue(`discount[${index}].end_date`, e);
                        convertLocalToUTCDate(e, `discount[${index}].end_date`);
                      }}
                       onBlur={() =>
    formik.setFieldTouched(
      `discount[${index}].end_date`,
      true
    )
  } 
                      minDate={
                        formik.values.discount?.[index]?.start_date ||
                        new Date()
                      }
                      customInput={
                        <MaskedInput
                          pipe={autoCorrectedDatePipe}
                          mask={dateMask}
                          keepCharPositions={true}
                          guide={true}
                        />
                      }
                    />
                    {getIn(formik.touched, `discount[${index}].end_date`) &&
  getIn(formik.errors, `discount[${index}].end_date`) && (
    <HintField
      error={getIn(formik.errors, `discount[${index}].end_date`)}
    />
)}
                  </Col>
                </>
              )}
              {formik.values?.discount?.[
                index
              ]?.discount_type?.toLowerCase() === 'amount' && (
                <Col className="col-sm-6">
                  <InputField
                    titleStyle={{
                      fontFamily: fontConfig.GeneralInputFieldFont.family,
                      fontWeight: '400',
                      fontSize: '12px',
                      lineHeight: '18px',
                      color: '#4F4F4F',
                    }}
                    style={{ backgroundColor: '#FFFFFF' }}
                    mandatory={true}
                    formik={formik}
                    title="Amount"
                     name={`discount[${index}].amount`}
                    placeholder="Amount"
                    checkValidation={true}
                    value={formik.values?.discount?.[index]?.amount}
                    handleChange={(e) =>
                      formik.setFieldValue(
                        `discount[${index}].amount`,
                        e?.target?.value.match(regex)[0]
                      )
                    }
                    onKeyPress={(event) => {
                      if (event.key === 'Enter') {
                        event.preventDefault();
                      }
                    }}
                    onBlur={formik.handleBlur} 
                  />
                </Col>
              )}
            </Row>
            {(orgDetails?.memberPortal && formik?.values?.allowNonMembers) && (
            <Row className="mb-5">
              <Col className="col-sm-6 member-only-discount">
                <MyCheckbox
                  title="Members only"
                  name="forMemberOnly"
                  handlechange={(e) => {
                    formik.setFieldValue(
                      `discount[${index}].forMemberOnly`,
                      e.target.checked
                    );
                  }}
                  checked={formik.values?.discount?.[index]?.forMemberOnly}
                  boxBgColor={"#FFFFFF"}
                />
              </Col>
            </Row>
            )}
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default DiscountAccordion;
